// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8230) return "static/chunks/8230-2e311b96af827bbd.js";
	if (chunkId === 3122) return "static/chunks/3122-e3a0cdc38a935551.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"321":"24174228ca97d454","1771":"82a2d87625094e8b","7688":"e79573bbc1348b3b"}[chunkId] + ".js";
};